module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov7-880fd51840c11730f95746ff1d8e2830.jpg";